import { Flex, Skeleton } from 'antd';

function PlantingGroupStageChartSkeleton() {
  return (
    <Flex
      justify="flex-start"
      gap={20}
      align="center"
      style={{ maxHeight: '100px' }}
    >
      <Skeleton.Avatar style={{ height: '120px', width: '120px' }} active />
      <Flex vertical gap={20}>
        <Skeleton.Input active />
        <Skeleton.Input active />
      </Flex>
    </Flex>
  );
}

export default PlantingGroupStageChartSkeleton;
